import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchasePivotChartsDetail, resetPurchasePivotCharts, createPurchasePivotChart } from '../../actions/purchaseOrders_actions';
import { createPurchaseQuote, resetCurrentPurchaseQuote } from '../../actions/purchaseQuotes_actions';
import { fetchVendors } from '../../actions/vendors_actions';
import PurchasePivotChartDetail from '../../components/Purchase/purchasePivotChartDetail';

let purchasePivotChartDetail = reduxForm({
  form: 'purchasePivotChartDetail',
})(PurchasePivotChartDetail);

const selector = formValueSelector('purchasePivotChartDetail');

function mapStateToProps(state) {
      vendor = selector(state, 'Vendor');
    return {
      vendor,
      vendors: state.vendors.all,
      vendorIsLoading: state.vendors.isLoading,
      vendorError: state.vendors.error,
      purchasePivot_id: state.purchaseOrders.purchasePivot_id,
      purchasePivotChartsDetailIsLoading: state.purchaseOrders.purchasePivotChartsDetailIsLoading,
      purchasePivotChartsDetail: state.purchaseOrders.purchasePivotChartsDetail,
      purchasePivotChartsDetailError: state.purchaseOrders.purchasePivotChartsDetailError,
      initialValues: state.purchaseOrders.purchasePivotChartsDetail,
      purchaseQuoteIsCreating: state.purchaseQuotes.purchaseQuoteIsCreating,
      purchaseQuoteCreateError: state.purchaseQuotes.purchaseQuoteCreateError,
      purchaseQuoteCreated: state.purchaseQuotes.purchaseQuoteCreated,

    };
}

export default connect(mapStateToProps, { fetchPurchasePivotChartsDetail, fetchVendors, resetPurchasePivotCharts, createPurchasePivotChart, createPurchaseQuote, resetCurrentPurchaseQuote })(purchasePivotChartDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasePivotChartDetail.jsx